// provincesData.js
const provincesData = {
  "چهارمحال و بختیاری": {
    "شهرکرد": ["شهرکرد", "هفشجان", "شهرکیان"],
    "لردگان": ["لردگان", "سردشت"],
    "بروجن": ["بروجن", "فرادنبه", "سفیددشت", "گندمان", "بلداجی"],
    "فارسان": ["فارسان", "جونقان", "باباحیدر"],
    "خانمیرزا": ["آلونی"],
    "کیار": ["شلمزار", "گهرو", "ناغان"],
    "اردل": ["اردل", "کاج", "دشتک"],
    "کوهرنگ": ["چلگرد", "بازفت", "صمصامی"],
    "فرخشهر": ["فرخشهر", "دستگرد", "سورک"],
    "سامان": ["سامان", "هوره"],
    "فلارد": ["مال‌خلیفه"],
    "بن": ["بن", "وردنجان", "یانچشمه"]
  }
};

export default provincesData;
